import * as React from 'react';

// tslint:disable:max-line-length
export const PassIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M10 2c0-1.1-.9-2-2-2S6 .9 6 2v2h4V2zM15 6H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zm-8 7H3V9h4v4zm6 0H9v-1h4v1zm0-3H9V9h4v1z" />
    </g>
  </svg>
);
